const StabilityContent = [
  {
    description: (
      <>
        <p>
          The urgency of the formation of energy harvesting with the least carbon
          footprint has led us to the evolution of third-generation solar cells. Among those, perovskite solar cells are the most promising in terms of power conversion efficiency. Yet the minimal thermal and moisture stability halts the commercialization of solar
          cells of this kind. Most of the preparation and storage of perovskite solar cells is done
          in a controlled environment. The unstable perovskite affects the commercialization as
          well as the accuracy of characterization and ease of research. Mounting every piece of
          equipment inside a controlled environment and accessing it using a rubber hand is not
          a very considerable condition for most researchers. Hence it is essential to define
          ways to stabilize the raw perovskite layer. Even if the lead iodide tends to revert from
          the formed perovskite film yet with proper solution engineering and annealing
          conditions, it is expected to achieve stabilized perovskite layer. We have tested
          different combinations of annealing conditions and additives to ensure the formation
          of ambient stable perovskite films. So that the time-consuming processing and
          characterizations would not cause damage to the perovskite sample while exposed to
          ambient conditions.
        </p>
        <br />
        <p>
          The document of the project is available in the following link.
        </p>
      </>
    ),
    badge: "Intro",
    image:
      "https://try-er.github.io/debasish/assets/images/project_images/perovskite_main.jpg",
    links: [
      {
        image: "./assets/images/exp_logos/CIPET.png",
        url: "https://drive.google.com/file/d/1gujccK3Vqqj9qmm__d3ywOpngdUBGO8y/view",
        text: "Stability Assessment in Metal Halide Perovskite with Incorporation of Organic Additives",
      }
    ]
  },
];

export { StabilityContent };